import type { Action } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';

interface SpotlightEligibilityState {
	isSpotlightCheckEnabled: boolean;
}

const initialState: SpotlightEligibilityState = {
	isSpotlightCheckEnabled: false,
};

const actions = {
	disableSpotlightCheck:
		(): Action<SpotlightEligibilityState> =>
		({ setState }) => {
			setState({ isSpotlightCheckEnabled: false });
		},
	enableSpotlightCheck:
		(): Action<SpotlightEligibilityState> =>
		({ setState }) => {
			setState({ isSpotlightCheckEnabled: true });
		},
};

const store = createStore({
	initialState,
	actions,
	name: 'SpotlightEligibilityStore',
});

export const useShouldCheckEligibilityForSpotlight = createHook(store);
